import listModules from './utils/listModules';

export default listModules({
    actions: {
        fetch: '/admin/element/list',
        save: '/admin/element/save',
        delete: '/admin/element/delete'
    }
});
